import { getCurrentInstance, SetupContext, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import { FeedLiked, Feed } from '@/api/feed';
import { FeedPageEnum } from '@/store/modules/feed';
import { ActionType, ActionBarProps } from './common';
import { radarLog } from '@/common/radar';

export const ActionBarAppSetup = (props: ActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    // const baseSetup = ActionBarBaseSetup(props, ctx);
    const { proxy } = getCurrentInstance() || {};
    // const { feedList } = baseSetup || {};

    const feedList = computed<Feed[]>(() => {
        const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
        return feedListOrigin?.[props?.feedPage || FeedPageEnum.PwaShareNew] || [];
    });

    const handleLikeAction = debounce(async (type: ActionType) => {
        const feedLikeStatus = type === ActionType.Like ? FeedLiked.Like : FeedLiked.UnLike;

        const newFeedList = feedList.value?.map?.(feed => {
            if (feed.photo_id_str === props?.photoId) {
                return {
                    ...feed,
                    liked: feedLikeStatus,
                };
            }
            return feed;
        });
        proxy?.$store?.commit?.('feedMoudle/resetFeedList', props.feedPage);
        proxy?.$store?.commit?.('feedMoudle/setFeedList', {
            [props?.feedPage || FeedPageEnum.PwaShareNew]: newFeedList || [],
        });
    }, 300);

    /**
     * @zh “举报”按钮点击
     * @zh feature：仅上报埋点
     */
    const handleReport = () => {
        radarLog({
            name: 'PWA_REPORT_APP',
        });
        Toast({
            message: proxy?.$root?.$t?.('report_successful_toast'),
            duration: 1500,
        });
    };

    const likeCount = (count: number) => {
        return (proxy?.$root?.$t('k_344306') || '') as string;
    };

    const commentCount = (count: number) => {
        return (proxy?.$root?.$t('k_467898') || '') as string;
    };

    const shareCount = (count: number) => {
        // app合规过审，多语言先写死Share，后续优化 @jinyao
        return 'Share';
    };

    return {
        handleLikeAction,

        handleReport,
        likeCount,
        commentCount,
        shareCount,
    };
};
